


/* router tests */
function testPage(location){
    return true;
}



function testAdd(x,y){ return x+y }

function computeTitleUrl(location, alert){
    return `${location.pathname}infos_trafic/`;
}

function computeAlertUrl(location,alert){
    var regex = /.*\/infos_trafic\/$/;
    var pageInfoTrafic =  regex.test(location.pathname);   
    if (pageInfoTrafic) return `#${alert.getId()}`;
    if (!pageInfoTrafic) return `${location.pathname}infos_trafic/#${alert.getId()}`
}





/* config */ 

export var config = {
    datasetProviders : [
        {
            provider : 'ban-search',
            name : 'ban-search',
            config : {
                limit : 10,
                autocomplete : false,
                bounds : { sw : { lat: 47.47, lon: 6.70}, ne: { lat: 47.77, lon: 7.06  }},  // belfort
                //bounds : { sw : { lat : 44.59, lon: -1.03}, ne : { lat : 45.06, lon: -0.36} },  // bordeaux
                maincity : 'Belfort'                   
            }
        },
        {
            provider : 'sig-belfort',
            name : 'sig-belfort-geojson',
            config : {
                url : 'https://sig.grandbelfort.fr/serveur/services/SIG/POI/MapServer/WFSServer?service=wfs&version=2.0.0&request=GetFeature&typeNames=SIG_POI:POI&outputFormat=GEOJSON&srsName=epsg4326'
            }
        },
        {
            provider : 'urbiplan',
            name : 'urbiplan-api-prod',
            config : {
                instance : 'belfort',
                env : 'prod',
                key : '76350b70682e051e6709782b551f5437173f1957',
                preferredLang : 'fr'
            }
        },
        {
            provider : 'urbiplan',
            name : 'urbiplan-api-preprod',
            config : {
                  instance: 'belfort',
                  env : 'preprod',
                  key : '134c234c03617029696b311409307f470c7f4003',
                  preferredLang : 'fr'
            }
        }
    ],

    defaultDatasetProviderConfigName : 'urbiplan-api-prod',

     
     routerConfigs :[ {
            test : testPage.toString(),
            viewConfigName : 'main1View1Config'
        }],

    href : {
    },
    
    options : {
        hasSelector : false
    }    
}




